export default "__VITE_ASSET__DuwRhHvz__"